import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    remoteDB: {},
    localDB: {},
    remoteUrl: 'https://db.minderal.com',
    isLoading: false,
    route: '/',
    logs: [],
    syncStatus: '',
    routeTrace: [],
    theme: 'dark',
    isDebugBarVisible: false
  },
  mutations: {
    setIsDebugBarVisible (state, value) {
      state.isDebugBarVisible = value
    },
    setRemoteDB (state, db) {
      state.remoteDB = db
    },
    startLoading (state) {
      state.isLoading = true
    },
    endLoading (state) {
      state.isLoading = false
    },
    setRoute (state, route) {
      state.route = route
    },
    setLocalDB (state, db) {
      state.localDB = db
    },
    setCurrentLocation (state, currentLocation) {
      state.currentLocation = currentLocation
    },
    pushLog (state, log) {
      state.logs.push({
        message: log,
        timestamp: new Date().toLocaleString() + '-' + state.logs.length
      })
    },
    setSyncStatus (state, status) {
      state.syncStatus = status
    },
    pushRoute (state, route) {
      if (route.documentId === '/') {
        state.routeTrace = [route]
        return
      }
      let routeIndex = state.routeTrace.findIndex(i => i.documentId === route.documentId)
      if (routeIndex !== -1) {
        state.routeTrace.splice(routeIndex + 1)
      } else {
        state.routeTrace.push(route)
      }
    },
    toggleTheme (state) {
      state.theme === 'light' ? state.theme = 'dark' : state.theme = 'light'
      document.body.className = ''
      document.body.classList.add(state.theme)
    }
  },
  actions: {
    async isCookieValid ({ state }) {
      let url = state.remoteUrl + '/_session'
      return axios.get(url, { withCredentials: true })
        .then((result) => {
          return !(result.data.userCtx.name == null)
        })
        .catch((err) => {
          if (err) return false
        })
    }
  }
})
